export default class SideMenu {
    constructor($timeout, $rootScope, PageMenu) {
        this.rootScope = $rootScope;
        this.timeout = $timeout;
        this.items = [];
        this.dropDown = true;
        this.active = null;
        this.pageMenu = PageMenu;
    }
    
    init() {
        if (this.items.length) {
            return;
        }

        this.add({translate_key: 'SIDEMENU:NEW_RULE', tooltipKey: 'SIDEMENU:NEW_RULE:TOOLTIP', state: 'v5', icon: 'line-icon line-icon-rocket'});
        this.add({translate_key: 'SIDEMENU:FEED', tooltipKey: 'SIDEMENU:FEED:TOOLTIP', state: 'dashboard', icon: 'line-icon line-icon-grid'});
        this.add({translate_key: 'SIDEMENU:EVENT', tooltipKey: 'SIDEMENU:EVENT:TOOLTIP', state: 'event', icon: 'line-icon line-icon-flag', role: 'Sogeti|Sogeti Admin', hideFor: 'Subscriber viewer|Campaign viewer'});
        this.add({translate_key: 'SIDEMENU:CAMPAIGN', tooltipKey: 'SIDEMENU:CAMPAIGN:TOOLTIP', state: 'campaign', icon: 'line-icon line-icon-envelope', hideFor: 'Sogeti|Sogeti Admin|Subscriber viewer'});
        this.add({translate_key: 'SIDEMENU:SUBSCRIBER', tooltipKey: 'SIDEMENU:SUBSCRIBER:TOOLTIP', state: 'subscriber', icon: 'line-icon line-icon-users', hideFor: 'Campaign viewer'});
        this.add({translate_key: 'SIDEMENU:TAG', tooltipKey: 'SIDEMENU:TAG:TOOLTIP', state: 'tag', icon: 'line-icon line-icon-tag', hideFor: 'Subscriber viewer|Campaign viewer'});
        this.add({translate_key: 'SIDEMENU:AUTOMATION', tooltipKey: 'SIDEMENU:AUTOMATION:TOOLTIP', state: 'automation', icon: 'line-icon line-icon-paper-plane', hideFor: 'Sogeti|Sogeti Admin|Subscriber viewer|Campaign viewer'});
        this.add({translate_key: 'SIDEMENU:IMAGE_BANK', tooltipKey: 'SIDEMENU:IMAGE_BANK:TOOLTIP', state: 'imagebank', icon: 'line-icon line-icon-picture', hideFor:'Subscriber viewer|Campaign viewer'});
        this.add({translate_key: 'SIDEMENU:TEMPLATE', tooltipKey: 'SIDEMENU:TEMPLATE:TOOLTIP', state: 'template', icon: 'line-icon line-icon-doc', role: 'Template editor', hideFor: 'Sogeti|Subscriber viewer|Campaign viewer'});
        this.add({translate_key: 'SIDEMENU:SETTING', tooltipKey: 'SIDEMENU:SETTING:TOOLTIP', state: 'setting', icon: 'line-icon line-icon-settings', hideFor: 'Subscriber viewer|Campaign viewer'});
        this.add({translate_key: 'SIDEMENU:DOCS', tooltipKey: 'SIDEMENU:DOCS:TOOLTIP', state: 'docs', icon: 'line-icon line-icon-book-open' });
    }
        
    add(item) {
        if (! item.hasOwnProperty('name')) {
            item.name = item.translate_key;
            this.items.push(item);
        }
    };

    getItems() {
        return this.items;
    };

    getActive() {
        return this.active;
    };

    getDropDownMenu() {
        return this.dropDown;
    };

    setActive(name) {
        if (! this.items.length) {
            this.timeout(() => {
                return this.setActive(name);
            }, 100);
        }

        _(this.items).each((item) => {
            item.active = 'inactive';
            
            if (item.state === name) {
                item.active = 'active';
                this.active = item;
                this.pageMenu.setActive(name);
            }
        })
    };
};

SideMenu.$inject = ['$timeout', '$rootScope', 'PageMenu'];
